"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyBarRightSlot = exports.StickyBarLeftSlot = exports.StickyBar = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _StickyBarModule = _interopRequireDefault(require("./StickyBar.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const StickyBarLeftSlot = _ref => {
  let {
    className,
    children,
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...props,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'leftSlot'
    }),
    className: (0, _classify.default)(_StickyBarModule.default.leftSlot, className),
    children: children
  });
};
exports.StickyBarLeftSlot = StickyBarLeftSlot;
const StickyBarRightSlot = _ref2 => {
  let {
    className,
    children,
    testId,
    ...props
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...props,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'rightSlot'
    }),
    className: (0, _classify.default)(_StickyBarModule.default.rightSlot, className),
    children: children
  });
};
exports.StickyBarRightSlot = StickyBarRightSlot;
const StickyBar = exports.StickyBar = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    className,
    children,
    position = 'bottom',
    testId,
    ...props
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...props,
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'stickyBar'
    }),
    className: (0, _classify.default)(_StickyBarModule.default.wrapper, {
      [_StickyBarModule.default.top]: position === 'top',
      [_StickyBarModule.default.bottom]: position === 'bottom'
    }, className),
    children: children
  });
});